type ExtensionLineProps = {
  from: [number, number];
  to: [number, number];
};

export const ExtensionLine = ({ from, to }: ExtensionLineProps) => {
  return (
    <line
      x1={from[0]}
      y1={from[1]}
      x2={to[0]}
      y2={to[1]}
      stroke="#000"
      strokeWidth={0.5}
      className="dimension-extension-line"
    />
  );
};
